import { GYPSUM } from 'HubStyleTokens/colors';
import { ECLIPSE } from 'developer-docs-shared-components/config/cssConstants';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import { getPathNames } from 'developer-docs-shared-components/utils/urls';
import UIRouterNavLink from 'ui-addon-react-router-dom/UIRouterNavLink';
import Link from 'UIComponents/link/UILink';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import UIList from 'UIComponents/list/UIList';
import { getLocalizedBadge } from '../utils/localization';
import { NESTED_NAV_ACTIVE_LINK_CLASSNAME, getSharedPillLinkStyles } from '../utils/css';
import { useSelector } from 'react-redux';
import { selectUserGates } from '../selectors/userState';
import { developerPlatformNavConfig, addToConfigIfUngated } from '../config/nav/guides/developerPlatform';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Nav = styled.nav.withConfig({
  displayName: "PrimaryNavSubmenu__Nav",
  componentId: "sc-1c7id6z-0"
})(["background:", ";padding:5px 40px;", "{padding-left:308px;}li{margin:0 1vw;&:first-child{margin-left:0;}", "{margin-left:32px;margin-right:32px;}}a{", " color:", ";&:hover,&:focus{color:", ";}&.", "{color:", ";background:", ";font-weight:600;}}"], ECLIPSE, mediaQueries.aboveLaptop, mediaQueries.aboveLaptop, getSharedPillLinkStyles(GYPSUM), GYPSUM, GYPSUM, NESTED_NAV_ACTIVE_LINK_CLASSNAME, ECLIPSE, GYPSUM);

/**
 * Submenu of SecondaryNavConfig items that shows in a blue row beneath the
 * primary nav when a primary item is open. Desktop only.
 */
const PrimaryNavSubmenu = ({
  primaryNavConfig
}) => {
  const {
    pathname
  } = useLocation();
  const {
    primaryDir
  } = getPathNames(pathname);
  const userGates = useSelector(selectUserGates);
  const matchingNavConfig = primaryNavConfig.find(({
    baseDirectory
  }) => baseDirectory === `/${primaryDir}`);
  if (!matchingNavConfig) {
    return null;
  }
  const secondaryNavConfigs = matchingNavConfig.getSecondaryNavConfigs();
  if (secondaryNavConfigs.length === 1) {
    return null;
  }
  // DDO-639 Hardcoded check for the correct gate for the hidden nav item
  if (addToConfigIfUngated(primaryDir, userGates.gates)) {
    secondaryNavConfigs.push(developerPlatformNavConfig);
  }
  return /*#__PURE__*/_jsx(ResponsiveRenderer, {
    renderDesktop: () => /*#__PURE__*/_jsx(Nav, {
      "data-test-id": "primary-nav-submenu",
      "aria-label": matchingNavConfig.label,
      children: /*#__PURE__*/_jsx(UIList, {
        inline: true,
        childClassName: "p-all-0",
        children: secondaryNavConfigs.map(fn => {
          const config = fn();
          const {
            commonPath,
            sectionLabel,
            badge
          } = config;
          const href = config.href;
          const content = /*#__PURE__*/_jsxs(_Fragment, {
            children: [sectionLabel, getLocalizedBadge(badge === 'BETA' ? 'BETA_SUFFIX' : badge)]
          });
          return href ? /*#__PURE__*/_jsx(Link, {
            href: href,
            external: true,
            children: content
          }, commonPath) : /*#__PURE__*/_jsx(UIRouterNavLink, {
            activeClassName: NESTED_NAV_ACTIVE_LINK_CLASSNAME,
            exact: false,
            to: commonPath,
            children: content
          }, commonPath);
        })
      })
    }),
    renderMobile: () => null
  });
};
export default PrimaryNavSubmenu;